import { render, staticRenderFns } from "./AppStory.vue?vue&type=template&id=5d885567&scoped=true&"
import script from "./AppStory.vue?vue&type=script&lang=js&"
export * from "./AppStory.vue?vue&type=script&lang=js&"
import style0 from "./AppStory.vue?vue&type=style&index=0&id=5d885567&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d885567",
  null
  
)

export default component.exports